import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AnchorBannerContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getDestaqueNavegacao(id: string): Observable<any> {
    return this.getDestaqueNavegacaoContents(id).pipe(
      map((res) =>
        this.buildResponseHighlightAnchorObject(this.extractResult(res))
      ),
      catchError((error) => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryDestaqueNavegacaoContents?.length > 0
      ? res.data.queryDestaqueNavegacaoContents[0].flatData
      : null;
  }

  private getDestaqueNavegacaoContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryDestaqueNavegacaoContents(filter: "id eq '${id}'") {
          flatData {
            nome
            navegarPara
            imagem {
              url
            }
            descricao
            filter
            botoes {
              uRL
              titulo
              cor
              modal {
                id
              }
            }
          }
        }
      }`,
    };

    return this.send(payload);
  }

  private buildResponseHighlightAnchorObject(highlightAnchor: any) {
    let buttons = [];
    if (highlightAnchor?.botoes) {
      buttons = highlightAnchor.botoes.map((button) => {
        let externalURL = false;
        if (button.uRL) {
          if (button.uRL.indexOf('http') >= 0) {
            externalURL = true;
          }
        }

        return {
          color: button.cor,
          title: button.titulo,
          url: button.uRL,
          modal: button.modal && button.modal[0] ? button.modal[0].id : '',
          router: externalURL ? null : button.uRL ? button.uRL : null,
          hrefTarget: externalURL ? '_blank' : null,
        };
      });
    }

    return {
      buttons,
      link: highlightAnchor?.navegarPara
        ? highlightAnchor?.navegarPara === 'Próxima seção'
          ? 'next'
          : 'previous'
        : highlightAnchor?.navegarPara,
      description: highlightAnchor?.descricao
        ? highlightAnchor?.descricao
        : highlightAnchor?.descricao,
      filter: highlightAnchor?.filter === 'Escuro' ? 'dark' : 'colors',
      image:
        highlightAnchor?.imagem &&
        highlightAnchor?.imagem &&
        highlightAnchor?.imagem[0]
          ? highlightAnchor?.imagem[0].url
          : '',
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
